import { Component, Input, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RenderArgs } from '@sds/custom-elements';

@Component({
	selector: 'app-table-cell-template-renderer',
	template: `
		<ng-container *ngTemplateOutlet="template; context: getContext()"></ng-container>
	`,
	standalone: true,
	imports: [CommonModule]
})
export class TableCellTemplateRendererComponent {
	@Input() args?: RenderArgs;
	@Input() template?: TemplateRef<any>;

	getContext() {
		if (!this.args) return {};
		return {
			$implicit: this.args.value,
			row: this.args.row
		};
	}
}
